<script setup>
import {nextTick, onMounted, ref } from 'vue'
import CustomMenu from "@/components/NewPC/CustomMenu.vue";
import {useRouter} from "vue-router";
import {getMedia, formatTimeTwo, throttle, debounce} from '@/utils/utils'
import {
  getJson,
  getAccountInfo,
  getReceiveStatus,
  getCardDuration,
  getReceive,
  createOrder,
  checkPlayerFun,
  loginStateFun,
  checkMessageFun
} from "@/api/common";
import storage from "@/utils/storage";
import {showImagePreview, showLoadingToast, showToast} from "vant";
import showIDTipsImg from '@/assets/newPc/topup/guide.jpg'
import coverIcon from '../assets/newPc/topup/cover.png'
import useAccount from '@/store/account'
import CardRule from "@/components/NewPC/CardRule.vue";
import CustomOrder from '@/components/NewPC/Order.vue'
import RightLightning from "@/components/NewPC/RightLightning.vue";
import LeftLightning from "@/components/NewPC/LeftLightning.vue";
import {useTgaStore} from "@/store/tga";
import CheckAccount from "@/components/NewPC/CheckAccount.vue";
import LoginDialog from "@/components/NewPC/LoginDialog.vue";
const tga = useTgaStore()
const router = useRouter()
const datetime = formatTimeTwo('YMDhm')
const goodsList = ref([]);
const cardList = ref([]);
const id = ref(null)
const CardRuleRef = ref(null)
const tempAccount = ref(null)
const show = ref(false)
const receiveStatus = ref(1)
const cardDuration = ref([]);
const accountStore = useAccount();
const orderNo = ref(null);
const CustomOrderRef = ref(null);
const CheckAccountRef = ref(null);
const notice_text = ref(null);

const loginStatus = ref(1); // 登录状态
const loginState = ref(); // 登录组件
const LoginDialogRef = ref(null);


const giftMap = {
  gift_6: require('@/assets/newPc/topup/gift_6.png'),
  gift_30: require('@/assets/newPc/topup/gift_30.png'),
  gift_60: require('@/assets/newPc/topup/gift_60.png'),
  gift_98: require('@/assets/newPc/topup/gift_98.png'),
  gift_328: require('@/assets/newPc/topup/gift_328.png'),
  gift_648: require('@/assets/newPc/topup/gift_648.png'),
}

const getGiftMap = id => {
  if (giftMap[`gift_${id}`]) return giftMap[`gift_${id}`];
  return ''
}

const handleJumpHome = () => {
  router.push('/')
}

// 查询专属礼物领取状态
const fetchReceiveStatus = (account) => {
  if (!account && !accountStore.getterAccount()) return;
  getReceiveStatus(account || id.value || accountStore.getterAccountId()).then(res => {
    if (res.status == 200 && res.data && res.data.code == 0) {
      receiveStatus.value = res.data.data.receive
    }
  })
}

const handleCancel = () => {
  tga.tgaTrack('web_campaigns_event', {
    web_campaigns_op: 'pc_fetch_account',
    account: accountStore.getterAccount() ? accountStore.getterAccount():'未绑定',
    gps1: id.value,
    gps2: "绑定失败",
    gps3: "取消绑定",
  })

  show.value = false
  tempAccount.value = null
  id.value = null
  storage.getStorage().removeItem('WEBSITE_PC_ACCOUNT_V2');
  accountStore.setterAccount(null);
}

const handleConfirm = async () => {
  const result = await checkPlayerFun({account: tempAccount.value.account})
  if (result && result.data.code == 0 && result.data.data.allowRecharge == true) {
    fetchReceiveStatus(id.value);

    storage.setWithExpiry('WEBSITE_PC_ACCOUNT_V2', JSON.stringify(tempAccount.value));
    accountStore.setterAccount(tempAccount.value);
    fetchCardDuration(); // 查询月卡、周卡剩余天数

    tga.tgaTrack('web_campaigns_event', {
      web_campaigns_op: 'pc_fetch_account',
      account: accountStore.getterAccount() ? accountStore.getterAccount():'未绑定',
      gps1: id.value,
      gps2: "绑定完成",
    })
  } else {
    showToast('仅支持从本渠道下载游戏的玩家账号进行充值！')
    // 用户存在，上报
    tga.tgaTrack('web_campaigns_event', {
      web_campaigns_op: 'pc_fetch_account',
      account: accountStore.getterAccount() ? accountStore.getterAccount():'未绑定',
      gps1: id.value,
      gps2: "绑定失败",
      gps3: "ID是渠道服账号",
    })

    show.value = false
    tempAccount.value = null
    id.value = null
    storage.getStorage().removeItem('WEBSITE_PC_ACCOUNT_V2');
    accountStore.setterAccount(null);
  }
}

const fetchCardDuration = () => {
  if (accountStore.getterAccount()) {
    getCardDuration(accountStore.getterAccount()).then(res => {
      if (res.status == 200 && res.data && res.data.code == 0) {
        cardDuration.value = res.data.data
        console.log('cardDuration.value:', cardDuration.value);
      }
    })
  }
}

// 获取头像
const getCover = (str) => {
  if (str && str != '1') {
    return `https://jqys-files.racoondigi.cn/ugc_pics/${str.split(',')[0]}`
  }
  return coverIcon;
}
const getCardDurationNum = (type) => {
  if (cardDuration.value && cardDuration.value.length) {
    const card = cardDuration.value.find(f => f.card_type === type)
    return card && (card.remaining_days || card.remaining_days == 0) ? card.remaining_days : -1
  }
  return -1;
}
const getGoods = () => {
  getJson().then((res) => {
    if (res.status === 200 && res.data && res.data.code == 0) {
      goodsList.value = res.data.data.topUp.goods.filter(f => f.type == 'ruby' || f.type == 'star')
      cardList.value = res.data.data.topUp.goods.filter(f => f.type == 'card')
      notice_text.value = res.data.data.topUp.notice?.replace(/\n/g, '<br />')
    }
  })
}

const handleShowReviewID = () => {
  showImagePreview({
    images: [showIDTipsImg],
    closeable: true
  });
}

const handleFetchAccount = () => {
  if (!id.value) {
    showToast('请先输入游戏ID')
    return
  }
  tga.tgaTrack('web_campaigns_event', {
    web_campaigns_op: 'pc_fetch_account',
    account: accountStore.getterAccount() ? accountStore.getterAccount():'未绑定',
    gps1: id.value,
    gps2: "输入ID"
  })

  getAccountInfo(id.value).then(res => {
    if (res.status == 200 && res.data && res.data.code == 0) {
      tempAccount.value = res.data.data
      show.value = true;
    } else {
      // showToast(res.data.msg)
      CheckAccountRef.value?.open();
      tga.tgaTrack('web_campaigns_event', {
        web_campaigns_op: 'pc_fetch_account',
        account: accountStore.getterAccount() ? accountStore.getterAccount():'未绑定',
        gps1: id.value,
        gps2: "绑定失败",
        gps3: "ID错误",
      })
    }
  })
}
// 领取专属礼物
const handleReceive = () => {
  if (loginState.value != 1) {
    if (!accountStore.getterAccount()) {
      showToast('请先输入游戏ID')
      return
    }
  } else {
    const token = storage.getWithExpiry('WEBSITE_PC_TOKEN')
    if (!token) {
      LoginDialogRef.value?.open();
      return
    }
  }
  getReceive(accountStore.account.invite_code).then(res => {
    if (res.status == 200 && res.data && res.data.code == 0 && res.data.data == true) {
      showToast('领取成功')
      receiveStatus.value = 2;
    } else {
      showToast(res.data.msg)
    }
  })
}

const handleShowCardRule = () => {
  CardRuleRef.value?.open()
}

const handleCreateOrder = throttle((row) => {
  if (loginState.value != 1) {
    if (!accountStore.getterAccount()) {
      showToast('请先输入游戏ID')
      return
    }
  } else {
    const token = storage.getWithExpiry('WEBSITE_PC_TOKEN')
    if (!token) {
      LoginDialogRef.value?.open();
      return
    }
  }

  tga.tgaTrack('web_campaigns_event', {
    web_campaigns_op: 'pc_order_delivered',
    account: accountStore.getterAccount() ? accountStore.getterAccount():'未绑定',
    gps1: accountStore.getterAccount() ? accountStore.account.invite_code:null,
    gps2: "点击商品",
    gps3: `${row.basic.name}|${row.basic.price}|${row.id}`,
    gps4: null,
  })

  const loading = showLoadingToast({mask: true})
  const data = {
    product_id: row.id,
    channel: 'website',
    extra_reward: row.gift,
    icon_url: row.gift.icon,
    type: '官网充值',
    account_id: accountStore.account.invite_code,
  }
  createOrder(data).then(res => {
    loading.close()
    if (res.status == 200 && res.data && res.data.code == 0) {
      orderNo.value = res.data.data.id
      CustomOrderRef.value?.open(orderNo.value, accountStore.account.invite_code)
    } else {
      showToast(res.data.msg)
    }
  })
}, 500)

const handleInputAccount = debounce((event) => {
  if (event.target.value.trim()) {
    tga.tgaTrack('web_campaigns_event', {
      web_campaigns_op: 'pc_page_exposure',
      account: accountStore.getterAccount() ? accountStore.getterAccount():'未绑定',
      gps1: event.target.value,
      gps2: "输入ID"
    })
  }
}, 300)

const showWechatDialog = () => {
  LoginDialogRef.value.open()

  tga.tgaTrack('web_campaigns_event', {
    web_campaigns_op: 'pc_login',
    account: accountStore.getterAccount() ? accountStore.getterAccount():'未绑定',
    gps1: '点击登录'
  })
}
// 查询登录开关
const getLoginState = () => {
  loginStateFun().then(res => {
    if (res.status == 200 && res.data && res.data.code == 0) {
      loginState.value = res.data.data.login
      localStorage.setItem('WEBSITE_LOGIN_STATE', JSON.stringify(loginState.value))
      if (loginState.value == 1) {
        tga.tgaTrack('web_campaigns_event', {
          web_campaigns_op: 'pc_login',
          account: accountStore.getterAccount() ? accountStore.getterAccount():'未绑定',
          gps1: '登录曝光'
        })
      }
    }
  })
}

const checkMessage = ({phone, code, remember}) => {
  const loading = showLoadingToast({
    overlay: true,
    duration: 0,
    forbidClick: true
  })
  checkMessageFun(phone, code, remember).then(res => {
    loading.close()
    if (res.status == 200 && res.data && res.data.code == 0) {
      handleEchoPlayerInfo({
        token: res.data.data.token,
        playerInfo: res.data.data.playerInfo,
      });
      tga.tgaTrack('web_campaigns_event', {
        web_campaigns_op: 'pc_login',
        account: res.data.data.playerInfo.account,
        gps1: '点击登录',
        gps2: "成功",
      })
    } else {
      showToast(res.data.msg)
      tga.tgaTrack('web_campaigns_event', {
        web_campaigns_op: 'pc_login',
        gps1: '点击登录',
        gps2: "失败",
        gps3: res.data.msg
      })
    }
  }).catch(() => {
    showToast("登录失败")
  })
}

const handleEchoPlayerInfo = data => {
  const remember = localStorage.getItem('WEBSITE_LOGIN_REMEMBER');
  storage.setWithExpiry('WEBSITE_PC_TOKEN', data.token, remember == 'true' ? 30 * 24 * 60:0);
  storage.setWithExpiry('WEBSITE_PC_ACCOUNT_V2', JSON.stringify(data.playerInfo), remember == 'true' ? 30 * 24 * 60:0);
  fetchReceiveStatus(data.playerInfo.invite_code);
  accountStore.setterAccount(data.playerInfo);
  fetchCardDuration(); // 查询月卡、周卡剩余天数
  loginStatus.value = 2;
  if (!data.notClosed) {
    LoginDialogRef.value?.open();
  }
  tga.tgaTrack('web_campaigns_event', {
    web_campaigns_op: 'pc_login',
    account: accountStore.getterAccount() ? accountStore.getterAccount():'未绑定',
    gps1: '切换账号曝光'
  })
}

const handleOutLogin = () => {
  // 清除缓存
  storage.getStorage().removeItem('WEBSITE_PC_ACCOUNT_V2')
  storage.getStorage().removeItem('WEBSITE_PC_TOKEN')
  accountStore.setterAccount(null);
  loginStatus.value = 1;

  tga.tgaTrack('web_campaigns_event', {
    web_campaigns_op: 'pc_login',
    account: accountStore.getterAccount() ? accountStore.getterAccount():'未绑定',
    gps1: '切换账号点击'
  })
}

onMounted(() => {
  getLoginState();
  getGoods();
  fetchCardDuration();
  fetchReceiveStatus();

  // 验证登录状态
  const token = storage.getWithExpiry('WEBSITE_PC_TOKEN')
  if (token) {
    loginStatus.value = 2;
    tga.tgaTrack('web_campaigns_event', {
      web_campaigns_op: 'pc_login',
      account: accountStore.getterAccount() ? accountStore.getterAccount():'未绑定',
      gps1: '切换账号曝光'
    })
  }

  tga.tgaLogin("202504_GUANWANG", accountStore.getterAccount() ? accountStore.getterAccount():'未绑定');
  // 用户存在，上报
  tga.tgaTrack('web_campaigns_event', {
    web_campaigns_op: 'pc_page_exposure',
    account: accountStore.getterAccount() ? accountStore.getterAccount():'未绑定',
    gps1: accountStore.getterAccount() ? accountStore.account.invite_code:null,
    gps2: "充值中心"
  })

  if (!id.value && accountStore.getterAccount()) {
    id.value = accountStore.account.invite_code;
  }
})

</script>

<template>
<div class="top_up_container">
  <div class="content">
    <custom-menu :active="5" />
    <img src="@/assets/newPc/topup/topup_logo.png" @click="handleJumpHome" alt="" class="logo_icon">
<!--    <custom-left-menu type="TopUp" class="left_menu" />-->


    <div class="account_block">
      <div class="player_info">
        <template v-if="loginState == 0">
          <img class="cover" v-if="!accountStore.getterAccount()" src="@/assets/newPc/topup/player_cover.png" alt="">
          <img class="cover" v-else :src="getCover(accountStore.account.portrait)" alt="">
          <span class="nickname" v-if="accountStore.getterAccount()">{{ accountStore.account.nickname }}</span>
        </template>
        <template v-if="loginState == 1">
          <img v-if="!accountStore.getterAccount()" class="cover" src="@/assets/newPc/topup/player_cover.png" alt="">
          <span v-if="!accountStore.getterAccount()" class="nickname">请登录</span>
          <img v-if="accountStore.getterAccount()" class="cover" :src="getCover(accountStore.account.portrait)" alt="">
          <span v-if="accountStore.getterAccount()" class="nickname">{{ accountStore.account.nickname }}</span>
        </template>
      </div>

      <div class="form_row">
        <template v-if="loginState == 1">
          <button v-if="loginStatus == 1" class="login_btn" @click="showWechatDialog">登录</button>
          <button v-else  class="login_btn" @click="handleOutLogin">切换账号</button>
        </template>
        <template v-else>
          <span class="label">输入游戏ID</span>
          <span class="show_tips_entry" @click="handleShowReviewID">点击查看游戏ID</span>
          <input v-model="id" @input="handleInputAccount" type="text">
          <button @click="handleFetchAccount">确定</button>
        </template>
      </div>
    </div>

<!--    <canvas ref="CardCanvasRef" style="width: 200px; height: 200px"></canvas>-->





    <div class="block">
      <!--   兔女郎   -->
      <div class="bunny_girl">
        <img src="@/assets/newPc/topup/bunny_girl_icon.png" alt="">
      </div>
      <div class="scroll_block">
        <!--   专属礼物   -->
        <div class="block_title" v-if="notice_text">
          <img src="@/assets/newPc/topup/notice_icon.png" alt="">
          <span>公告</span>
        </div>
        <div class="notice_block" v-if="notice_text">
          <div v-html="notice_text"></div>
        </div>
        <!--   专属礼物   -->
        <div class="block_title">
          <img src="@/assets/newPc/topup/gift_title_icon.png" alt="">
          <span>专属礼物</span>
        </div>
        <div class="gift_block">
          <div>
            <span>官方充值平台购买任意商品，可获得专属头像框和称号!</span>
            <img class="cover_icon" src="@/assets/newPc/topup/cover_icon.png" alt="">
            <img class="title_icon" src="@/assets/newPc/topup/title_icon.png" alt="">
          </div>
          <button :disabled="receiveStatus != 1" @click="handleReceive">{{ receiveStatus == 2 ? '已领取':'领取' }}</button>
        </div>
        <!--   商品   -->
        <div class="block_title">
          <img src="@/assets/newPc/topup/goods_title_icon.png" alt="">
          <span>商品</span>
        </div>
        <div class="card_goods">
          <div class="card_block" v-for="item of cardList" :data-type="item.basic.type" @click="handleCreateOrder(item)">
            <div class="card_head">
              <img class="card_item" v-if="item.basic.type == 'week'" src="@/assets/newPc/topup/week_item.png" alt="">
              <img class="card_item" v-else src="@/assets/newPc/topup/month_item.png" alt="">
              <div>
                <div class="card_title" :data-type="item.basic.type">
                  <span>{{ item.basic.name }}</span>
                  <img src="@/assets/newPc/topup/card_tips.png" @click.stop="handleShowCardRule" alt="">
                </div>
                <div class="card_info remaining" :data-type="item.basic.type">
                  <span  v-if="getCardDurationNum(item.basic.type) > 0">权益生效中，剩余{{getCardDurationNum(item.basic.type)}}天</span>
                  <span  v-else-if="getCardDurationNum(item.basic.type) == 0">权益已过期</span>
                  <span  v-else>权益未激活</span>
                </div>
                <div class="card_info" :data-type="item.basic.type">立即获得{{ item.delivery.num }}红宝石</div>
                <div class="card_info" :data-type="item.basic.type">每日可额外获得{{ item.delivery.num_first }}红宝石</div>
              </div>
            </div>
            <button>购买￥{{ item.basic.price }}</button>
          </div>
        </div>

        <div class="goods_block">
          <div class="goods_item" v-for="item of goodsList"  @click="handleCreateOrder(item)">
            <div class="goods_intro">
              <img class="gift_icon_block" :src="getGiftMap(item.delivery.num_first)" alt="">
              <img class="goods_icon" :src="getMedia(datetime, `/hammer/jqys_v3/icons/${item.basic.icon}.png`)" alt="">
              <div :style="{color: item.type == 'ruby'?'#FF0000':'#F425FF' }">{{ item.type == 'ruby' ? '宝石X':'星星币X' }}{{ item.delivery.num }}</div>
            </div>
            <button>购买￥{{item.basic.price}}</button>
          </div>
        </div>
      </div>
      
    </div>

<!--    <gift-entry class="gift_entry" />-->

    <van-dialog v-model:show="show" show-cancel-button @cancel="handleCancel" @confirm="handleConfirm">
      <div class="dialog_content" v-if="tempAccount">
        <img class="cover" :src="getCover(tempAccount.portrait)" alt="">
        <div>账号：{{tempAccount.invite_code}}</div>
        <div>昵称：{{tempAccount.nickname}}</div>
      </div>
    </van-dialog>
    <card-rule ref="CardRuleRef" />
    <custom-order ref="CustomOrderRef" />
    <left-lightning class="left_lightning" type="top-up" />
    <right-lightning class="right_lightning" type="top-up" />
  </div>
  <check-account ref="CheckAccountRef" />

  <login-dialog ref="LoginDialogRef" @check-message="checkMessage" @echo-player-info="handleEchoPlayerInfo" />

</div>
</template>

<style scoped lang="scss">
@import '@/style/fonts.scss';

.top_up_container {
  width: 100vw;
  height: 100vh;
  background: transparent url("@/assets/newPc/topup/top_up_bg.png") no-repeat top center;
  background-size: cover;

  .content {
    width: 100vw;
    height: 100vh;
    background: transparent url("@/assets/newPc/topup/top_up_h_bg.png") no-repeat top center;
    background-size: contain;
    position: relative;

    .left_lightning {
      position: absolute;
      left: 0;
      top: 33.3203125vw;
    }

    .right_lightning {
      position: absolute;
      right: 0;
      top: 8.671875vw;
    }

    .logo_icon {
      position: absolute;
      left: 2.265625vw;
      top: 2.03125vw;
      width: 7.3046875vw;
      height: 4.0234375vw;
    }

    .left_menu {
      position: absolute;
      top: 16.09375vw;
      left: 2.96875vw;
      z-index: 2;
    }

    .account_block {
      height: 13.3984375vw;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      align-items: center;
      padding-bottom: 2.265625vw;
      box-sizing: border-box;

      div {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;

      }

      input {
        width: 10.3515625vw;
        height: 1.484375vw;
        background: #FFFFFF;
        padding: 0.5vw;
        box-sizing: border-box;
      }

      .label {
        color: #555555;
        font-size: 0.9375vw;
        font-family: 'SourceHanSansCN-Medium';
        margin-right: 0.234375vw;
      }

      button {
        width: 5.078125vw;
        height: 1.484375vw;
        border: none;
        font-family: 'SourceHanSansCN-Medium';
        font-size: 0.859375vw;
        color: #fff;
        background: transparent url("@/assets/newPc/topup/search_btn_bg.png") no-repeat center center;
        background-size: contain;
        margin-left: 0.3515625vw;
      }

      .player_info {
        display: flex;
        flex-direction: row;
        align-items: center;
        font-family: 'SourceHanSansCN-Bold';
        color: #fff;
        font-size: 1.3671875vw;
        margin-bottom: 1.4453125vw;

        .cover {
          width: 2.96875vw;
          height: 2.96875vw;
          border-radius: 50%;
        }
      }

      .form_row {
        position: relative;

        .show_tips_entry {
          position: absolute;
          left: 0.15vw;
          bottom: -0.5vw;
          color: #FF3380;
          font-family: 'SourceHanSansCN-Normal';
          font-size: 0.625vw;
          font-weight: bold;
          cursor: pointer;
        }

        .login_btn {
          width: 13.125vw;
          height: 2.0703125vw;
          color: #fff;
          background: transparent url("@/assets/newPc/topup/login_btn_bg.png") no-repeat center center;
          background-size: contain;
        }
      }
    }

    .block {
      width: 71.6796875vw;
      height: 30.9375vw;
      margin-left: 16.953125vw;
      background-color: #fff;
      position: relative;
      box-sizing: border-box;
      padding: 0.9375vw 0 0.9375vw 11.3828125vw;
      z-index: 1;

      .scroll_block {
        width: 60.46875vw;
        height: 29.0625vw;
        overflow-x: hidden;
        overflow-y: auto;
        padding: 0.9375vw 0;
        box-sizing: border-box;
      }

      .bunny_girl {
        width: 27.109375vw;
        height: 51.328125vw;
        position: absolute;
        left: -15.8984375vw;
        top: -8.2421875vw;

        img {
          width: 27.109375vw;
          height: 51.328125vw;
        }
      }

      .block_title {
        display: flex;
        flex-direction: row;
        align-items: center;
        padding-top: 0.9375vw;

        img {
          width: 1.4453125vw;
          height: 1.4453125vw;
          margin-right: 0.3515625vw;
        }

        span {
          color: #FF8C16;
          font-family: 'SourceHanSansCN-Heavy';
          font-size: 0.8984375vw;
        }
      }

      .notice_block {
        background-color: #FFF4DA;
        width: 58.7890625vw;
        padding: 1.25vw 1.71875vw;
        box-sizing: border-box;
        color: #555555;
        margin-top: 0.1953125vw;
      }

      .gift_block {
        margin-top: 0.234375vw;
        width: 58.7890625vw;
        height: 4.8046875vw;
        background: transparent url("@/assets/newPc/topup/gift_bg.png") no-repeat center center;
        background-size: contain;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        padding: 0.78125vw 0.703125vw 0.78125vw 1.953125vw;
        box-sizing: border-box;
        margin-bottom: 0.3125vw;
        div {
          display: flex;
          flex-direction: row;
          align-items: center;
          color: #555555;
          font-size: 0.859375vw;
          font-family: 'SourceHanSansCN-Regular';

          .cover_icon {
            width: 3.3203125vw;
            height: 3.3203125vw;
            margin-left: 1.5234375vw;
          }

          .title_icon {
            width: 9.0234375vw;
            height: 3.28125vw;
            margin-left: 0.859375vw;
          }
        }

        button {
          width: 9.765625vw;
          height: 2.3046875vw;
          color: #fff;
          font-size: 1.09375vw;
          font-family: 'SourceHanSansCN-Bold';
          background: linear-gradient(to right , #FF7E22, #FFAA16, #FDC110);
          border: none;

          &[disabled] {
            background: #ddd;
            color: #333;
            font-family: 'SourceHanSansCN-Bold';
          }
        }
      }

      .card_goods {
        display: flex;
        flex-direction: row;
        align-items: center;

        .card_block {
          width: 28.9453125vw;
          height: 8.984375vw;
          position: relative;
          text-align: right;


          &[data-type="week"] {
            background: transparent url("@/assets/newPc/topup/week_card_bg.png") no-repeat center center;
            background-size: contain;
            margin-right: 0.859375vw;
          }
          &[data-type="month"] {
            background: transparent url("@/assets/newPc/topup/month_card_bg.png") no-repeat center center;
            background-size: contain;
          }

          .card_head {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
          }

          .card_item {
            width: 11.484375vw;
            height: 9.140625vw;
          }

          .card_title {
            padding-top: 1.171875vw;
            font-size: 1.171875vw;
            text-align: right;
            font-family: 'SourceHanSansCN-Heavy';
            padding-right: 2.34375vw;
            box-sizing: border-box;
            margin-bottom: 0.78125vw;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: flex-end;
            position: relative;
            &[data-type="week"] {
              span {
                color: #103464;
              }
            }
            &[data-type="month"] {
              span {
                color: #643C10;
              }
            }

            img {
              position: absolute;
              right: 0.8203125vw;
              width: 1.0546875vw;
              height: 1.0546875vw;
            }
          }


          .card_info {
            text-align: right;
            color: #5B6672;
            padding-right: 2.34375vw;
            font-size: 0.703125vw;
            margin-bottom: 0.1953125vw;

            &[data-type="week"] {
              color: #5B6672;
            }
            &[data-type="month"] {
              color: #706551;
            }


            &.remaining {
              height: 0.9765625vw;
              &[data-type="week"] {
                font-family: 'SourceHanSansCN-Bold';
                color: #103464;
              }
              &[data-type="month"] {
                font-family: 'SourceHanSansCN-Bold';
                color: #643c10;
              }
            }
          }

          button {
            width: 9.4140625vw;
            height: 2.34375vw;
            border: none;
            color: #fff;
            font-family: 'SourceHanSansCN-Bold';
            font-size: 1.09375vw;
            background: linear-gradient(to right , #FF7E22, #FFAA16, #FDC110);
            margin-top: -0.4296875vw;
          }
        }
      }

      .goods_block {
        margin-top: 4.140625vw;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;

        .goods_item {
          width: 9.4140625vw;
          height: 10.78125vw;
          background: transparent url("@/assets/newPc/topup/goods_bg.png") no-repeat center center;
          background-size: contain;
          margin-right: 0.46875vw;
          margin-bottom: 1.7578125vw;
          position: relative;

          &:nth-child(6n) {
            margin-right: 0;
          }

          .goods_intro {
            width: 9.4140625vw;
            height: 10.78125vw;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            color: #FF0000;
            font-size: 0.6640625vw;
            position: relative;

            .gift_icon_block {
              width: 4.1796875vw;
              height: 3.2421875vw;
              position: absolute;
              top: -0.7421875vw;
              right: -0.1953125vw;
              background-size: contain;
            }

            .goods_icon {
              width: 6.25vw;
              height: 6.25vw;
              margin-bottom: 1.5625vw;
            }

            &>div {
              position: absolute;
              left: 0;
              right: 0;
              bottom: 2.5vw;
              text-align: center;
            }
          }

          button {
            position: absolute;
            left: 0;
            right: 0;
            bottom: 0;
            height: 2.265625vw;
            background: linear-gradient(to right , #FF7E22, #FFAA16, #FDC110);
            border: none;
            font-family: 'SourceHanSansCN-Bold';
            font-size: 1.09375vw;
            color: #fff;
          }
        }
      }
    }
    .gift_entry {
      position: absolute;
      top: 29.5703125vw;
      right: 1.640625vw;
      z-index: 1;
    }
  }
}


.dialog_content {
  padding: 1.171875vw 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #fff;

  .cover {
    width: 4.6875vw;
    height: 4.6875vw;
    border-radius: 50%;
    margin-bottom: 0.390625vw;
  }

  div {
    font-size: 0.859375vw;
    margin-bottom: 0.390625vw;
  }
}


</style>